






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierInboundDocument } from '@/store/models/IDossierInboundDocument';

@Component({ components: { Snackbar } })
export default class DossierInboundsDocuments extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  documents: IDossierInboundDocument[] = [];
  loadingDocuments = false;

  async mounted() {
      await this.loadInboundDocuments();
  }

  async loadInboundDocuments() {
      if (!this.inboundCode) return;

      this.loadingDocuments = true;

      try {
          const data = await this.dossierApi.DossierReadInboundDocuments(this.inboundCode);
          this.documents = data;
      } catch (err) {
          console.error(err);
      } finally {
          this.loadingDocuments = false;
      }
  }

  formatDate(dateStr: string): string {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }

  documentHeaders = [
      { text: 'Document Type', value: 'custompapername' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', value: 'actions', sortable: false }
  ];
}
